<div class="step-container">
  <div class="d-flex flex-column justify-content-between h-100">
    <div class="mb-0">
      <div class="container p-3 rounded bg-white">
        <div>
          <h5 class="font-size-18 mb-2">
            {{ 'refer.confirm.modal.refer.friend' | translate }}
          </h5>
          <div class="font-size-14 mb-3">
            {{ 'refer.confirm.modal.refer.code' | translate }}
          </div>
          <div class="row g-2">
            <div class="col-md">
              <form [formGroup]="referralCodeForm">
                <div class="form-floating">
                  <input
                    type="Referral Code"
                    class="form-control"
                    formControlName="friendKey"
                    id="floatingInputGrid"
                    placeholder="12345678"
                  />
                  <label for="floatingInputGrid">{{ 'confirm.modal.refer.code' | translate }}</label>
                </div>
                <div
                  class="error-message"
                  *ngIf="referralCodeForm.get('friendKey')?.invalid && referralCodeForm.get('friendKey')?.touched"
                >
                  {{ 'refer.a.friend.code.required' | translate }}
                </div>
              </form>
            </div>
            <div class="col-md"></div>
          </div>
        </div>
        <div class="d-flex justify-content-end action-wrapper">
          <button type="button" class="btn btn-cancel close" (click)="backToLogin()">
            {{ 'confirm.modal.cancel' | translate }}
          </button>
          <button type="button" class="btn fw-bold btn-success" (click)="submit()">
            {{ 'confirm.modal.submit' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
